import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../config/api-client";
import { API_ENDPOINTS } from "../config/api-endpoints";
import type { UsageAnalyticsResponse } from "../models/api-types";

/**
 * Hook to fetch user usage analytics
 * @returns Query result with usage analytics data
 */
export const useUsageAnalytics = (params?: {
  startDate?: string;
  endDate?: string;
}) => {
  return useQuery<UsageAnalyticsResponse>({
    queryKey: ["usageAnalytics", params],
    queryFn: async () => {
      const response = await apiClient.get(
        API_ENDPOINTS.getUserUsageAnalytics,
        params ? { params } : undefined
      );
      return response as any;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: false,
  });
};
